import SessionStorage from '@/services/session-storage'

const state = {
    title: (SessionStorage.get('app') || {}).title,
};

const mutations = {
    SET_TITLE(state, title) {
        state.title = title;
    }
};

const actions = {
    setTitle(context, title) {
        context.commit('SET_TITLE', title)
    }
};

export default {
    state,
    mutations,
    actions
}
